module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-09.94bd51ab.png";